<template>
  <div class="base-banner" v-if="!hidden">
    <div class="title" v-if="$slots.title">
      <slot name="title" />
    </div>
    <div class="content" v-if="$slots.content">
      <slot name="content" />
    </div>
    <div class="button" v-if="$slots.button">
      <slot name="button" />
    </div>
    <div class="close" @click="handleClose" v-if="cookieName" />
  </div>
</template>

<script>
import cookies from 'js-cookie'
export default {
  props: {
    cookieName: {
      type: String,
      required: true
    }
  },
  created() {
    this.hidden = this.cookieName && cookies.getJSON(this.cookieName)
  },
  data: () => ({
    hidden: false
  }),
  methods: {
    handleClose() {
      cookies.set(this.cookieName, true, { sameSite: 'none', secure: true })
      this.hidden = cookies.getJSON(this.cookieName)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-banner {
  width: 100%;
  position: relative;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: var(--br-1);
  border-bottom-right-radius: var(--br-1);
  border: var(--border-1);
  border-top: solid 2px var(--color-cyan-1);
  background: var(--color-cyan-2);
  padding: var(--spacing-4);
  color: var(--color-gray-3);
  z-index: 1;
}
.title {
  font-weight: var(--fw-medium);
  margin-bottom: var(--spacing-2);
}
.content {
  margin-bottom: var(--spacing-4);
}
.close {
  position: absolute;
  top: var(--spacing-4);
  right: var(--spacing-4);
  width: 2rem;
  height: 2rem;
  pointer-events: all;
  background-image: url('../../assets/img/close.svg');
  background-size: fit;
  background-position: center center;
  background-repeat: no-repeat;
  cursor: pointer;
  &::after {
    content: '';
    position: absolute;
    width: calc(100% + 0.5rem * 2);
    height: calc(100% + 0.5rem * 2);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: var(--color-gray-2);
    border-radius: 3px;
    z-index: -1;
    opacity: 0;
    transition: opacity 0.2s;
  }
  &:hover::after {
    opacity: 1;
  }
}
</style>
